export default __webpack_public_path__ + "static/media/pastaDash.36c92608.svg";